import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_CLINIC_INSURANCE_COLLECTION_NAME = "clinic-insurance";

export const useRxCollectionClinicInsurance =
  (): RxCollection<ClinicInsurance> | null =>
    useRxCollection<ClinicInsurance>(RXDB_CLINIC_INSURANCE_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<ClinicInsurance>>;
export type ClinicInsuranceQueryConstructor = UseRxData["1"];

const CLINIC_INSURANCE_SCHEMA_LITERAL = {
  title: "clinic insurance schema",
  version: 0,
  description:
    "Insurance configuration for the clinic (facility-scoped, pull-only)",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    facilityId: {
      type: "string",
      maxLength: 100,
    },
    dailyRebateAmount: {
      type: ["number", "null"],
    },
    healthProviderCode: {
      type: ["string", "null"],
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "facilityId", "meta"],
  encrypted: ["dailyRebateAmount", "healthProviderCode", "meta"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(CLINIC_INSURANCE_SCHEMA_LITERAL);

export type ClinicInsurance = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const CLINIC_INSURANCE_SCHEMA: RxJsonSchema<ClinicInsurance> =
  CLINIC_INSURANCE_SCHEMA_LITERAL;
